import { VStack } from "@chakra-ui/react"
import React from "react"
import { CreatePhoneDeviceForm } from "../../forms"

export const CreatePhoneDevice: React.FC = () => {
	return (
		<VStack w="full" maxW="sm" spacing={6}>
			<CreatePhoneDeviceForm />
		</VStack>
	)
}
